import script from "./GoodList.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodList.vue?vue&type=script&setup=true&lang=js"

import "./GoodList.vue?vue&type=style&index=0&id=56a24e6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a24e6c"]])

export default __exports__